import Component from './src/Component.vue'
export default Component

const Options = {
  labels: {
    primary: 'Primærfarge',
    secondary: 'Sekundærfarge',
  },
}
const setup = options => {
  for (let key in options) {
    if (!(key in Options)) return
    Options[key] = options[key]
  }
}

export { setup, Options }
